<section>
  <div class="container mt-4 mb-4">
    <div class="row container-padding">
      <div class="col-12">
        <fieldset class="error-bg">
          <div class="text-center error-page py-5 my-4">
            <h2 class="mb-4">HELLO... You're at the right place, just the wrong page!</h2>
            <a class="click-txt" routerLink="/">
              <span class="pe-1 red-txt">CLICK HERE</span>
              <span>TO START AT HOME.</span>
            </a>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</section>
<app-subscribe></app-subscribe>